const CSS_ACTIVE = "is-active";
const CSS_INACTIVE = "is-inactive";
const CSS_LOADING = "is-loading";
const CSS_POSITIVE = "is-positive";
const CSS_NEGATIVE = "is-negative";
const CSS_PRIME = "is-prime";
const CSS_HIGH = "is-high";

const BreakdownGrid = document.querySelector('.BreakdownGrid');
const BreakdownContent = BreakdownGrid.querySelector('.BreakdownGrid-content');
const TabCombined = BreakdownGrid.querySelector('.BreakdownGridTab[data-id="combined"]');
const TabHeatmap = BreakdownGrid.querySelector('.BreakdownGridTab[data-id="heatmap"]');
const TabDownload = BreakdownGrid.querySelector('.BreakdownGridTab[data-id="download"]');
const BreakdownCategoryTabs = BreakdownGrid.querySelectorAll('.BreakdownGrid-categories .Tab');
const BreakdownCategorySelect = BreakdownGrid.querySelector('.BreakdownGrid-categories .TabContainer-dropdown');
const BreakdownTooltip = BreakdownGrid.querySelector('.BreakdownTooltip');
const BreakdownTooltipLabel = BreakdownTooltip.querySelector('.BreakdownTooltip-label');
const BreakdownTooltipValue = BreakdownTooltip.querySelector('.BreakdownTooltip-value');

const CombinedTable = document.getElementById("combined-table");
const CombinedPin = CombinedTable.querySelector("thead .BreakdownTable-pin");
const CombinedForm = CombinedTable.querySelector("#combined-search-form");
const CombinedSearch = CombinedForm.querySelector(".BreakdownTable-input");
const CombinedTargetSelect = CombinedTable.querySelector("select.BreakdownTable-targetSelect");
const CombinedBody = CombinedTable.querySelector(".BreakdownTable-body");
const CombinedRowTemplate = document.getElementById('table-row-combined');

const HeatmapTable = document.getElementById("heatmap-table");
const HeatmapPin = HeatmapTable.querySelector("thead .BreakdownTable-pin");
const HeatmapForm = HeatmapTable.querySelector("#heatmap-search-form");
const HeatmapSearch = HeatmapForm.querySelector(".BreakdownTable-input");
const HeatmapBody = HeatmapTable.querySelector(".BreakdownTable-body");
const HeatmapRowTemplate = document.getElementById('table-row-heatmap');

const TAB_COMBINED = 0;
const TAB_HEATMAP = 1;
const CATEGORY_WARFRAME = 0;
const CATEGORY_PRIMARY = 1;
const CATEGORY_SECONDARY = 2;
const CATEGORY_MELEE = 3;

const SEARCH_DEBOUNCE = 250;

const ContentData = window.PageData.contentData;
const WarframeStats = {};
const TableRows = [];
let PersistentPins = {};

let currentYear = window.PageData.currentYear;
let targetYear = window.PageData.targetYear;
let inputLockout = true;
let currentTab = TAB_COMBINED;
let currentCategory = CATEGORY_WARFRAME;
let search = "";
let searchDebounce = null;
let activeHeatmapCell = null;

// Occlude table body with spinner
function startLoading() {
    BreakdownGrid.classList.toggle(CSS_LOADING, true);
}
// Hide spinner, show body
function endLoading() {
    BreakdownGrid.classList.toggle(CSS_LOADING, false);
}

function noopHandler(e) {
    e.stopPropagation();
    e.preventDefault();
}
CombinedForm.addEventListener('submit', noopHandler);
HeatmapForm.addEventListener('submit', noopHandler);

// Helper for safely emptying all child elements out of a DOM node
function clearChildren(element) {
    if (element) {
        while (element.firstChild) {
            element.removeChild(element.lastChild);
        }
    }
}

// Build table contents from empty
function initTable() {
    clearHeatmapLabel();
    if (currentTab === TAB_HEATMAP) {
        clearChildren(HeatmapBody);
        initHeatmap();
    } else {
        clearChildren(CombinedBody);
        initCombined();
    }

    if (search) doSearch(search);

    // Clean up
    endLoading();
    inputLockout = false;
}

// Sort comparator
function tableRowComparator(left, right) {
    // Pinned items first
    let v = right.pinned - left.pinned;
    if (v !== 0) return v;

    // Search relevance second
    v = right.relevance - left.relevance;
    if (v !== 0) return v;

    // Sort by current year value
    return right.currentVal - left.currentVal;
}

// Resort and shuffle table rows
function syncTableRows() {
    const ActiveBody = currentTab === TAB_HEATMAP ? HeatmapBody : CombinedBody;
    const ActivePin = currentTab === TAB_HEATMAP ? HeatmapPin : CombinedPin;
    clearChildren(ActiveBody);
    let anyPinned = false;

    TableRows.sort(tableRowComparator);

    for (const row of TableRows) {
        if (!search || row.pinned || row.relevance > 0) {
            ActiveBody.appendChild(row.element);
        }
        anyPinned = anyPinned || row.pinned;
    }

    ActivePin.classList.toggle(CSS_ACTIVE, anyPinned);
}

// Search input debouncer
function searchInputHandler(e) {
    if (inputLockout) {
        e.preventDefault();
        return;
    }
    if (searchDebounce) {
        clearTimeout(searchDebounce);
        searchDebounce = null;
    }
    searchDebounce = setTimeout(() => {
        doSearch(e.target.value);
    }, SEARCH_DEBOUNCE);
}

// Actual search handler
function doSearch(str="") {
    search = str.toLowerCase().trim();
    const tokens = search.split(/\s+/);

    for (const row of TableRows) {
        row.relevance = 0;
        if (search) {
            // Full exact match
            if (row.nameLower === search) {
                row.relevance = 1000;
            }
            // Contains full search
            else if (row.nameLower.includes(search)) {
                row.relevance = 100;
            }
            // Token search
            else {
                for (const token of tokens) {
                    if (token && row.nameLower.includes(token)) {
                        row.relevance += 10;
                    }
                }
            }
        }
    }

    syncTableRows();
}

function clearPins(e) {
    e.stopPropagation();

    PersistentPins = {};
    for (const row of TableRows) {
        row.setPinned(false);
    }
    syncTableRows();
}

function initCombined() {
    TableRows.length = 0;

    switch (currentCategory) {
        case CATEGORY_PRIMARY:
            initCombinedWeapons(ContentData.primary, 'Primary');
            break;
        case CATEGORY_SECONDARY:
            initCombinedWeapons(ContentData.secondary, 'Secondary');
            break;
        case CATEGORY_MELEE:
            initCombinedWeapons(ContentData.melee, 'Melee');
            break;
        default:
            initCombinedWarframes(ContentData.warframes);
            break;
    }

    syncTableRows();
}
function initCombinedWarframes(data) {
    for (const warframe of data) {
        const row = makeCombinedTableRow(warframe);
        if (row) {
            TableRows.push(row);
        }
    }
}
function initCombinedWeapons(data, key) {
    for (const weapon of data) {
        const row = makeCombinedTableRow(weapon, key);
        if (row) {
            TableRows.push(row);
        }
    }
}

function initHeatmap() {
    TableRows.length = 0;

    switch (currentCategory) {
        case CATEGORY_PRIMARY:
            initHeatmapWeapons(ContentData.primary, 'Primary');
            break;
        case CATEGORY_SECONDARY:
            initHeatmapWeapons(ContentData.secondary, 'Secondary');
            break;
        case CATEGORY_MELEE:
            initHeatmapWeapons(ContentData.melee, 'Melee');
            break;
        default:
            initHeatmapWarframes(ContentData.warframes);
            break;
    }

    syncTableRows();
}
function initHeatmapWarframes(data) {
    for (const warframe of data) {
        const row = makeHeatmapTableRow(warframe);
        if (row) {
            TableRows.push(row);
        }
    }
}
function initHeatmapWeapons(data, key) {
    for (const weapon of data) {
        const row = makeHeatmapTableRow(weapon, key);
        if (row) {
            TableRows.push(row);
        }
    }
}

function getCurrentYearData(category, id) {
    return WarframeStats[currentYear]['ALL'][category][id];
}
function getCurrentYearMax(category) {
    return WarframeStats[currentYear]['ALL'][category].max || 1;
}
function getTargetYearData(category, id) {
    if (targetYear === 2020 || targetYear === 2021) id = id.toUpperCase();
    return WarframeStats[targetYear]['ALL'][category][id];
}
function getTargetYearMax(category) {
    return WarframeStats[targetYear]['ALL'][category].max || 1;
}

function formatPercent(val, precision=2) {
    val *= 100.0;
    return val.toFixed(precision) + '%';
}

// Generate row for Combined table
function makeCombinedTableRow(data, key='Warframe') {
    const CurrentYearData = getCurrentYearData(key, data.id);
    const CurrentYearMax = getCurrentYearMax(key);
    const TargetYearData = getTargetYearData(key, data.id);
    const TargetYearMax = getTargetYearMax(key);
    const MaxBarValue = Math.max(CurrentYearMax, TargetYearMax);

    if (CurrentYearData) {
        const clone = CombinedRowTemplate.content.cloneNode(true);
        const row = clone.querySelector('.BreakdownTable-row');
        const pin = row.querySelector('.BreakdownTablePin');
        const plate = row.querySelector('.BreakdownNameplate');
        const image = plate.querySelector('.BreakdownNameplate-image');
        const name = plate.querySelector('.BreakdownNameplate-name');
        const label = plate.querySelector('.BreakdownNameplate-label');
        const year = label.querySelector('.BreakdownNameplate-year');
        const current = row.querySelector('.BreakdownTable-currentCell');
        const target = row.querySelector('.BreakdownTable-targetCell');
        const change = row.querySelector('.BreakdownTable-changeCell');
        const chart = row.querySelector('.BreakdownChart');
        const targetWrapper = chart.querySelector('.BreakdownChart-targetWrapper');
        const targetBar = targetWrapper.querySelector('.BreakdownChart-target');
        const currentWrapper = chart.querySelector('.BreakdownChart-currentWrapper');
        const currentBar = currentWrapper.querySelector('.BreakdownChart-current');

        if (key === 'Warframe') {
            plate.href = window.PageData.warframeUrl + '/' + data.slug;
        }

        image.src = data.imageUrl;
        name.innerText = data.name;
        name.classList.toggle(CSS_PRIME, data.isPrime);
        if (data.released && year) {
            const release = new Date(data.released);
            year.innerText = release.getFullYear();
        } else {
            label.classList.add(CSS_INACTIVE);
        }
        const currentVal = CurrentYearData.ALL;
        current.innerText = formatPercent(currentVal);
        currentBar.style.height = formatPercent(currentVal / MaxBarValue);

        if (TargetYearData) {
            const targetVal = TargetYearData.ALL;
            target.innerText = formatPercent(targetVal);
            if (targetVal > 0) {
                const delta = currentVal / targetVal;
                if (delta > 1) {
                    change.classList.toggle(CSS_POSITIVE, true);
                    change.innerText = '+' + formatPercent(delta - 1);
                } else if (delta < 1) {
                    change.classList.toggle(CSS_NEGATIVE, true);
                    change.innerText = '-' + formatPercent(1 - delta);
                }
            }
            targetBar.style.height = formatPercent(targetVal / MaxBarValue);
        } else {
            targetWrapper.classList.toggle(CSS_INACTIVE, true);
        }

        const entry = {
            ...data,
            nameLower: data.name.toLowerCase(),
            currentVal,
            element: row,
            relevance: 0
        };
        entry.pinned = !!PersistentPins[entry.nameLower];
        pin.classList.toggle(CSS_ACTIVE, entry.pinned);

        entry.setPinned = (pinned) => {
            entry.pinned = !!pinned;
            pin.classList.toggle(CSS_ACTIVE, entry.pinned);
            PersistentPins[entry.nameLower] = entry.pinned;
        };

        pin.addEventListener('click', (e) => {
            e.stopPropagation();
            entry.setPinned(!entry.pinned);
            syncTableRows();
        });

        return entry;
    }
    return null;
}

function paintHeatmapCell(cell, label, value, maxBarValue, isHigh) {
    const weight = value / maxBarValue;
    const red = 255;
    const green = 255 - (255 * weight);
    cell.style.backgroundColor = `rgb(${red},${green},${green})`;
    cell.classList.toggle(CSS_HIGH, isHigh);
    addHeatmapLabel(cell, label, formatPercent(value,3));
}
function addHeatmapLabel(cell, label, text) {
    cell.setAttribute('data-label', label);
    cell.setAttribute('title', text);
    cell.addEventListener('click', (e) => {
        e.stopPropagation();
        if (activeHeatmapCell === cell) {
            clearHeatmapLabel();
        } else {
            activateHeatmapLabel(cell);
        }
    });
}
function activateHeatmapLabel(cell) {
    if (cell.hasAttribute('title')) {
        BreakdownTooltipLabel.innerText = cell.getAttribute('data-label');
        BreakdownTooltipValue.innerHTML = cell.getAttribute('title').replace(/\n/g, '<br />');

        const base = BreakdownContent.getBoundingClientRect()
        const rect = cell.getBoundingClientRect();
        BreakdownTooltip.style.top = (rect.bottom - base.top) + 'px';
        BreakdownTooltip.style.left = (rect.left - base.left + rect.width / 2) + 'px';
        BreakdownTooltip.classList.toggle(CSS_ACTIVE, true);
        activeHeatmapCell = cell;
    } else {
        BreakdownTooltip.classList.toggle(CSS_ACTIVE, false);
    }
}
function clearHeatmapLabel() {
    BreakdownTooltip.classList.toggle(CSS_ACTIVE, false);
    activeHeatmapCell = null;
}

// Generate row for Heatmap table
function makeHeatmapTableRow(data, key='Warframe') {
    const CurrentYearData = getCurrentYearData(key, data.id);

    if (CurrentYearData) {
        const clone = HeatmapRowTemplate.content.cloneNode(true);
        const row = clone.querySelector('.BreakdownTable-row');
        const pin = row.querySelector('.BreakdownTablePin');
        const plate = row.querySelector('.BreakdownNameplate');
        const image = plate.querySelector('.BreakdownNameplate-image');
        const name = plate.querySelector('.BreakdownNameplate-name');
        const label = plate.querySelector('.BreakdownNameplate-label');
        const year = label.querySelector('.BreakdownNameplate-year');
        const DetailedCells = row.querySelectorAll('.BreakdownTable-detailedCell .BreakdownTable-heatCell');
        const CompactCells = row.querySelectorAll('.BreakdownTable-compactCell .BreakdownTable-heatCellWide');
        const LegendaryCells = row.querySelectorAll('.BreakdownTable-legendaryCell .BreakdownTable-heatCell');

        if (key === 'Warframe') {
            plate.href = window.PageData.warframeUrl + '/' + data.slug;
        }

        image.src = data.imageUrl;
        name.innerText = data.name;
        name.classList.toggle(CSS_PRIME, data.isPrime);
        if (data.released) {
            const release = new Date(data.released);
            year.innerText = release.getFullYear();
        } else {
            label.classList.add(CSS_INACTIVE);
        }

        let maxBarValue = 0;
        let maxRank = 0;
        for (let i = 1; i <= window.PageData.maxMasteryRank; i++) {
            if (maxBarValue < CurrentYearData[i]) {
                maxBarValue = CurrentYearData[i];
                maxRank = i;
            }
        }

        if (maxBarValue > 0) {
            DetailedCells.forEach((cell, index) => {
                const rank = index + 1;
                paintHeatmapCell(cell, window.PageData.masteryRankString.replace(':num', rank), CurrentYearData[rank], maxBarValue, rank === maxRank)
            });
            CompactCells.forEach((cell, index) => {
                const base = 10 * index + 1;
                let weight = 0;
                const values = [];
                for (let i = 0; i < 10; i++) {
                    const rank = base + i;
                    if (rank === maxRank) {
                        cell.classList.add(CSS_HIGH);
                        cell.classList.add(CSS_HIGH + i);
                    }
                    weight = Math.max(weight, CurrentYearData[rank] / maxBarValue);
                    values.push(rank + ': ' + formatPercent(CurrentYearData[rank], 3));
                }
                const red = 255;
                const green = 255 - (255 * weight);
                cell.style.backgroundColor = `rgb(${red},${green},${green})`;
                addHeatmapLabel(cell, window.PageData.masteryRankString.replace(':num', `${base} - ${base+9}`), values.join('\n'));
            });
            LegendaryCells.forEach((cell, index) => {
                const rank = index + 31;
                paintHeatmapCell(cell, window.PageData.legendaryRankString.replace(':num', index + 1), CurrentYearData[rank], maxBarValue, rank === maxRank)
            });
        }

        const entry = {
            ...data,
            nameLower: data.name.toLowerCase(),
            element: row,
            currentVal: CurrentYearData.ALL,
            relevance: 0
        };
        entry.pinned = !!PersistentPins[entry.nameLower];
        pin.classList.toggle(CSS_ACTIVE, entry.pinned);

        entry.setPinned = (pinned) => {
            entry.pinned = !!pinned;
            pin.classList.toggle(CSS_ACTIVE, entry.pinned);
            PersistentPins[entry.nameLower] = entry.pinned;
        };

        pin.addEventListener('click', (e) => {
            e.stopPropagation();
            entry.setPinned(!entry.pinned);
            syncTableRows();
        });

        return entry;
    }
    return null;
}

function findMaxValue(data) {
    for (const categoryKey in data.ALL) {
        const category = data.ALL[categoryKey];
        let max = 0;
        for (const itemKey in category) {
            const item = category[itemKey];
            if (max < item.ALL) max = item.ALL;
        }
        category.max = max;
    }
}
async function fetchData(requestedItems=[]) {
    startLoading();
    const promises = [];
    const handlers = [];

    requestedItems.forEach((item) => {
        if (!WarframeStats[item]) {
            if (window.PageData[item]) {
                promises.push(
                    fetch(window.PageData[item]).then((response) => response.json())
                );
                handlers.push((result) => {
                    findMaxValue(result);
                    WarframeStats[item] = result;
                });
            } else {
                console.error('Unrecognized data request: ' + item);
            }
        }
    });

    try {
        const results = await Promise.all(promises);
        results.forEach((result, index) => {
           handlers[index](result);
        });

    } catch (error) {
        console.error(error);
    }
}

function switchToCombined() {
    currentTab = TAB_COMBINED;
    TabCombined.classList.toggle(CSS_ACTIVE, true);
    TabHeatmap.classList.toggle(CSS_ACTIVE, false);
    TabDownload.classList.toggle(CSS_ACTIVE, false);

    CombinedTable.classList.toggle(CSS_INACTIVE, false);
    clearChildren(CombinedBody);
    HeatmapTable.classList.toggle(CSS_INACTIVE, true);
    clearChildren(HeatmapBody);

    CombinedSearch.value = search;

    initTable();
}
function switchToHeatmap() {
    currentTab = TAB_HEATMAP;
    TabCombined.classList.toggle(CSS_ACTIVE, false);
    TabHeatmap.classList.toggle(CSS_ACTIVE, true);
    TabDownload.classList.toggle(CSS_ACTIVE, false);

    CombinedTable.classList.toggle(CSS_INACTIVE, true);
    clearChildren(CombinedBody);
    HeatmapTable.classList.toggle(CSS_INACTIVE, false);
    clearChildren(HeatmapBody);

    HeatmapSearch.value = search;

    initTable();
}

function changeTargetYear(year) {
    targetYear = year;
    fetchData([currentYear, targetYear]).then(() => {
        initTable();
    });
}

function changeCategory(cat, updateSelect=true) {
    currentCategory = cat;
    BreakdownCategoryTabs.forEach((tab, index) => {
       tab.classList.toggle(CSS_ACTIVE, index === currentCategory);
    });

    if (updateSelect) {
        BreakdownCategorySelect.value = currentCategory;
    }

    initTable();
}

function initTabs() {
    CombinedTargetSelect.addEventListener('change', (e) => {
        e.stopPropagation();
        if (!inputLockout) {
            inputLockout = true;

            changeTargetYear(parseInt(CombinedTargetSelect.value));
        }
        clearHeatmapLabel();
    });
    BreakdownCategoryTabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
            e.stopPropagation();
            if (!inputLockout) {
                inputLockout = true;

                changeCategory(index);
            }
            clearHeatmapLabel();
        });
        const option = document.createElement('option');
        option.value = "" + index;
        option.innerText = tab.getAttribute('data-label');
        BreakdownCategorySelect.appendChild(option);
    });
    BreakdownCategorySelect.addEventListener('change', (e) => {
        e.stopPropagation();
        if (!inputLockout) {
            inputLockout = true;

            changeCategory(parseInt(BreakdownCategorySelect.value), false);
        }
        clearHeatmapLabel();
    });

    TabCombined.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!inputLockout) {
            inputLockout = true;
            startLoading();
            switchToCombined();
        }
        clearHeatmapLabel();
    });
    CombinedPin.addEventListener('click', clearPins);
    CombinedSearch.addEventListener('input', searchInputHandler);

    TabHeatmap.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!inputLockout) {
            inputLockout = true;
            startLoading();
            switchToHeatmap();
        }
        clearHeatmapLabel();
    });
    TabDownload.addEventListener('click', (e) => e.stopPropagation());

    HeatmapPin.addEventListener('click', clearPins);
    HeatmapSearch.addEventListener('input', searchInputHandler);

    BreakdownGrid.addEventListener('click', () => {
       clearHeatmapLabel();
    });
}

window.addEventListener('DOMContentLoaded', () => {
    if (window.PageData) {
        fetchData([currentYear, targetYear]).then(() => {
            initTable();
        });
    }
    initTabs();
    window.addEventListener('resize', () => {
        clearHeatmapLabel();
    });
});
